module.exports = {"pathContext":{"name":"CensusAssignmentStatus","kind":"ENUM","type":"OBJECT","fields":null,"description":null,"enumValues":[{"deprecationReason":null,"description":null,"isDeprecated":false,"name":"RESERVED"},{"deprecationReason":null,"description":null,"isDeprecated":false,"name":"OCCUPIED"}],"possibleTypes":null}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/enum-census-assignment-status.json
// module id = 1218
// module chunks = 123358100903443